var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4773_57686)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7073 1.91504C13.7601 1.91504 15.4244 3.66396 15.4244 5.82126C15.4244 7.97754 13.7618 9.72595 11.7097 9.72747C9.65736 9.72595 7.9941 7.97805 7.99265 5.82126H7.99023C7.99023 3.66396 9.65422 1.91504 11.7073 1.91504Z",
    fill: "url(#paint0_linear_4773_57686)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0819 0.0820312H1.46586H1.43448C1.32659 0.0985185 1.22835 0.155336 1.15691 0.241831L1.01933 0.371193C1.00702 0.44323 1.0005 0.516281 1.00002 0.589332C1.00002 1.44921 1.91722 1.53545 1.91722 1.53545C2.44533 1.66684 2.80859 2.17592 2.78131 2.74536C2.7818 2.84936 2.77118 2.9531 2.74994 3.05481C2.67004 3.21918 2.62708 3.40029 2.62442 3.58494C2.62442 4.26219 3.34853 4.49301 3.34853 4.49301C3.7422 4.68325 3.9925 5.09822 3.98815 5.55327C3.98767 5.76304 3.94567 5.97027 3.86505 6.16203C3.71685 6.34847 3.63189 6.58132 3.62369 6.82406C3.62369 7.38209 4.18366 7.69915 4.18366 7.69915C4.45447 7.91755 4.61522 8.25364 4.62053 8.6123C4.61209 8.90958 4.51964 9.19722 4.35503 9.4392C4.1209 9.6165 3.97753 9.89704 3.96643 10.2001C3.99081 10.5142 4.13008 10.8059 4.35503 11.0144C4.52495 11.2282 4.62126 11.4966 4.62778 11.7753C4.61233 12.1538 4.45303 12.5101 4.18607 12.7646C3.86264 12.9018 3.64734 13.2277 3.63817 13.594C3.64855 13.8502 3.73303 14.097 3.87954 14.3017C3.96595 14.4841 4.01277 14.6842 4.01712 14.8876C4.01712 15.5978 3.36301 15.9758 3.36301 15.9758C2.78373 16.1584 2.63891 16.5465 2.63891 16.8737C2.6418 17.0606 2.67946 17.245 2.74994 17.4165C2.77866 17.5352 2.79338 17.6567 2.79338 17.7792C2.79338 18.6721 1.91722 18.9435 1.91722 18.9435C1.13519 18.9967 1.00002 19.5599 1.00002 19.915C0.999538 20.0053 1.0075 20.0953 1.02416 20.1838L1.14725 20.3005C1.22835 20.3799 1.32997 20.4322 1.43931 20.4502H11.0844C14.129 20.4608 16.6054 17.8759 16.6155 14.6761C16.6209 12.9769 15.9161 11.3609 14.688 10.256C16.9913 8.16587 17.2465 4.50925 15.2576 2.08841C14.2108 0.814067 12.688 0.0820312 11.0865 0.0820312C11.0846 0.0820312 11.0834 0.0820312 11.0819 0.0820312ZM11.4159 1.81799C13.4687 1.81799 15.133 3.56691 15.133 5.72421C15.133 7.88049 13.4704 9.62891 11.4183 9.63043C9.36597 9.62891 7.70271 7.881 7.70126 5.72421H7.69884C7.69884 3.56691 9.36283 1.81799 11.4159 1.81799Z",
    fill: "url(#paint1_linear_4773_57686)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7986 5.69684C12.7986 4.99373 12.2467 4.42383 11.5658 4.42383C11.3366 4.42383 11.1221 4.4884 10.9382 4.60088C11.0317 4.68696 11.0906 4.81229 11.0906 4.95183C11.0906 5.21144 10.8868 5.42187 10.6354 5.42187C10.5414 5.42187 10.454 5.39245 10.3815 5.34204C10.3499 5.45465 10.333 5.5737 10.333 5.69684C10.333 6.39995 10.8849 6.96985 11.5658 6.96985C12.2467 6.96985 12.7986 6.39995 12.7986 5.69684Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4773_57686",
    x: 0.802273,
    y: 0.0820312,
    width: 16.0107,
    height: 21.225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.659089
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0988633
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.85098 0 0 0 0 0.85098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4773_57686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4773_57686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4773_57686",
    x1: 17.3143,
    y1: 3.87883,
    x2: 13.4299,
    y2: 0.0994907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4773_57686",
    x1: 1.15207,
    y1: -0.0899372,
    x2: 1.15207,
    y2: 19.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4600DB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.56e3871d.svg";
export { ForwardRef as ReactComponent };